import axios from 'axios'

axios.interceptors.request.use(
    (config) => {
        config.headers.site = 'adminVexado';

        return config;
    }
);
